import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import {
  getVentureBlockchainPaginated,
  IVentureBlockchainPaginatedResponse,
} from "api";
import { Nullable } from "config";
import { RootState } from "store/store";

import { IVentureBlockchainModalData } from "./types";
import { VentureBlockchainModalMode } from "./enums";

const actionTypeName = "venture-blockchain";

const initialState = {
  ventureBlockchainData: null as Nullable<
    IVentureBlockchainPaginatedResponse["edges"]
  >,
  totalCount: 1,
  loading: false,
  modalData: {
    open: false,
    mode: VentureBlockchainModalMode.VIEW,
  } as IVentureBlockchainModalData,
};

export const fetchVentureBlockchainList = createAsyncThunk(
  `${actionTypeName}/fetchVentureBlockchainList`,
  async (_, { getState }) => {
    const filters = (getState() as RootState).FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }

    const response = await getVentureBlockchainPaginated(filters);
    return response;
  }
);

const ventureBlockchainSlice = createSlice({
  name: actionTypeName,
  initialState,
  reducers: {
    setVentureBlockchainModalData: (
      state,
      action: PayloadAction<IVentureBlockchainModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeVentureBlockchainModal: (state) => {
      state.modalData = initialState.modalData;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchVentureBlockchainList.fulfilled, (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          loading: false,
        };
      }
      return {
        ...state,
        ventureBlockchainData: action.payload?.edges,
        totalCount: action.payload?.totalCount,
        loading: false,
      };
    });
    builder.addCase(fetchVentureBlockchainList.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const { setVentureBlockchainModalData, closeVentureBlockchainModal } =
  ventureBlockchainSlice.actions;

export default ventureBlockchainSlice.reducer;
